export default {
  user: {
    myWorksList: `api/user/works/list`,
    myStatics: `api/user/index/myStatics`,
    collect: `api/user/works/enshrine`,
    myCollectList: `api/user/works/myEnshrines`,
    taCollectList: `api/user/works/hisEnshrines`,
    commentMsg: `api/user/message/commentMessage`,
    enshrinesMsg: `api/user/message/enshrinesMessage`,
    systemMsg: `api/user/message/systemMessage`,
    msgDetail: `api/user/message/messageDetail`,
    hisWorks: `/api/user/works/hisWorks`,
    hisStatics: `api/user/index/hisStatics`,
    saveIntro: `api/user/updateIntro`,
  },
  notification: {
    readAll: '/api/user/message/readAll',
    delete: '/api/user/message/deleteComment'
  },
  works: {
    enshrine: `api/user/works/enshrine`,
    unEnshrine: `api/user/works/cancelEnshrine`,
    comment: `api/works/comment`,
    commentList: `api/works/comment/list`,
    commentDel: `api/works/comment/delete`,
    commentLike: `api/works/comment/praise`,
    commentUnLike: `api/works/comment/cancelPraise`,
    reply: `api/works/reply`,
    replyDel: `api/works/reply/delete`,
    replyList: `api/works/reply/list`,
    replyLike: `api/works/reply/praise`,
    replyUnLike: `api/works/reply/cancelPraise`,
    report: `/api/works/report`,
    reportComment: `/api/works/comment/report`,
    reportReply: `/api/works/reply/report`,
    reportUser: `/api/works/user/report`,
  },
  discovery: {
    banner: `api/index/discovery/banner`
  },
  common: {
    upload: 'api/nos/upload/file'
  }
}
